import React from 'react';
import NatureGallery from './NatureGallery';
import MiniBio from './MiniBio';

const NatureSection = () => {
    return (
        <div className="App">
            <NatureGallery />
            <MiniBio />
        </div>
    );
};

export default NatureSection;